import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router-dom";


export const SiteFooter = ({ navAction }) => {


    const appRoutes = [
        { path: "/", pageTitle: 'Startseite' },
        { path: "/about", pageTitle: 'Über uns' },
        { ref: 'servRef', pageTitle: "Leistungen" },
        { path: "/contact", pageTitle: "Kontakt" }
    ];

    const handleNavAction = () => {
        navigateTo("/",{state: "service"});
    }

 

    const navigateTo = useNavigate();

    return (
        <footer className="app-footer">
            <div className="footer-top">
                <div className="footer-section">
                    <div className="flx-rw c-al app-id">
                        <img
                            className="logo-img"
                            alt=""
                            src="/act-color.png"
                            loading="lazy"
                        />
                        <div className="flx-col ca-l c-jt">
                            <div className="app-footer-name">SCHNELLENTRÜMPELUNG</div>
                            <div className="footer-slogan">Entrümpelung & Haushaltsauflösung</div>
                        </div>
                    </div>

                    <div className="app-slogan">
                        Professionelle Entrümpelung und Haushaltsauflösung in ganz Berlin.
                    </div>
                </div>
                <div className="footer-section flx-col lnks">
                    <div className="section-caption">Schnellzugriff</div>
                    {appRoutes.map((appRoute, index) => (
                        <button
                            className={classNames(
                                "q-link",
                                "tr-btn"
                            )}
                            key={index}
                            onClick={() => {
                                appRoute.ref ?
                                    handleNavAction() :
                                    navigateTo(appRoute.path)
                            }}
                        >
                            {appRoute.pageTitle}
                        </button>
                    ))}
                </div>
                <div className="footer-section">
                    <div className="section-caption">Kontaktieren Sie uns</div>
                    <div className="contact-unit">
                        <FontAwesomeIcon icon={faPhoneAlt} />
                        <span className="contact-data">+4917622006681</span>
                    </div>
                    <div className="contact-unit flx-rw c-al">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span className="contact-data">actreinigung@gmail.com</span>
                    </div>
                </div>
            </div>
            <hr />
            <div className="footer-bottom">
                <span className="copy-r">© 2026 Schnellentrepelung. Alle Rechte vorbehalten.</span>
                <a href="/impressum" className="footerlink">Impressum</a>
                <a href="/privacy" className="footerlink">Datenschutz</a>
                <a href="/terms" className="footerlink">AGB</a>
            </div>
        </footer>
    )
}